import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {MatLegacyRadioModule as MatRadioModule} from '@angular/material/legacy-radio';
import {LetModule, PushModule} from '@ngrx/component';
import {IncrementInputModule} from '@spout/global-web/ui';
import {AddonStorageComponent} from './addon-storage.component';

@NgModule({
  declarations: [AddonStorageComponent],
  imports: [
    CommonModule,
    IncrementInputModule,
    MatRadioModule,
    ReactiveFormsModule,
    LetModule,
    PushModule
  ],
  exports: [AddonStorageComponent]
})
export class AddonStorageModuleModule {}
